module.exports = __webpack_public_path__ + "static/flamingo-be3ecf2637dc5bb92ca2cf5b63a05e67.svg";